(() => {
  const CDN = 'https://cdn.shopify.com/s/files/1/0909/8264/6100/files';
  const root = document.querySelector('[data-rm-options]');
  if (!root) return;

  const form = root.closest('form') || document.querySelector('[data-rm-product-form]');
  if (form) form.noValidate = true;
  const mount = root.querySelector('[data-rm-options-mount]');
  const priceEl = document.querySelector('.rm-pdp__price [itemprop="price"]');
  const addBtn = form?.querySelector('[data-rm-add]');
  const assetUrl = root.dataset.optionsUrl;
  const basePrice = Number(root.dataset.basePrice || 0);
  const moneyFormat = root.dataset.moneyFormat || '{{amount}}€';

  const state = {
    config: null,
    values: {}, // id -> string | string[] | File[]
    files: {}, // id -> File[]
  };

  const cartRoot = () => {
    const r = window.Shopify?.routes?.root || '/';
    return r.endsWith('/') ? r : `${r}/`;
  };

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return moneyFormat.replace('__AMOUNT__', amount).replace('{{amount}}', amount);
  };

  const en = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const EXACT = {
    'Détail du casque': 'Helmet details',
    'Détail du pilote': 'Rider details',
    'Détail de la moto': 'Bike details',
    Design: 'Design',
    Matières: 'Materials',
    Marque: 'Brand',
    'Choisis une marque': 'Choose a brand',
    'Choisis un modèle': 'Choose a model',
    '— Choisir —': '— Choose —',
    'Nom sur le kit': 'Name on the kit',
    'Numéro sur le kit': 'Number on the kit',
    'Typo du nom': 'Name typeface',
    'Typo du numéro': 'Number typeface',
    'Ajoute une photo de la typo de nom que tu souhaites.': 'Add a photo of the name typeface you want.',
    'Ajoute une photo de la typo de numéro que tu souhaites.': 'Add a photo of the number typeface you want.',
    'Couleur principale': 'Main colour',
    'Couleur secondaire': 'Secondary colour',
    'Couleur tertiaire / petit détails': 'Third colour / small details',
    'Décris tes idées du design': 'Describe your design ideas',
    'Idées de design': 'Design ideas',
    'Ajoute des idées de designs que tu as pu voir.': 'Add design ideas you have seen.',
    'Tu veux des logos ?': 'Do you want logos?',
    "Liste les logos dans l'ordre du plus important au moins important.": 'List the logos from most important to least important.',
    'Ajoute ici tes logos perso': 'Add your own logos here',
    "Nous avons la majorité des logos du milieu MX, inutile d'ajouter des logos de ce milieu. Max 20 logos": 'We already have most MX logos, so you do not need to add those. Max 20 logos.',
    "Base d'impression": 'Print base',
    Lamination: 'Laminate',
    'Encre blanche ?': 'White ink?',
    "Cela permet d'avoir du blanc sur une base chrome ou holographique. Souvent utilisé pour avoir des numéros ou fonds de plaques blanches.": 'This prints white on a chrome or holographic base. Often used for white numbers or number plates.',
    'Si tu as des commentaires à ajouter :': 'Anything else to add:',
    'Choisir un fichier': 'Choose a file',
    'Champ obligatoire : ': 'Required field: ',
    'Sélectionne au moins une option : ': 'Select at least one option: ',
    'Variante produit introuvable': 'Product variant not found',
    'Préparation…': 'Preparing…',
    'Envoi des photos…': 'Uploading photos…',
    'Ajout au panier…': 'Adding to cart…',
    'Options indisponibles. Réessaie plus tard.': 'Options are unavailable. Try again later.',
    'Impossible de charger les options': 'Could not load the options',
    'Impossible d’envoyer la photo « ': 'Could not upload photo “',
    ' ». Réessaie ou réduis la taille du fichier. (': '”. Try again or reduce the file size. (',
  };
  const tr = (s) => {
    if (!en || s == null || s === '') return s;
    const raw = String(s);
    if (EXACT[raw]) return EXACT[raw];
    const model = raw.match(/^Modèle de (.+)$/);
    if (model) return `${model[1]} model`;
    return raw;
  };
  const trShow = (s) => {
    if (!en || s == null) return s;
    return String(s)
      .replace(/TOUTES TAILLES/gi, 'ALL SIZES')
      .replace(/\bENFANT\b/g, 'KIDS')
      .replace(/^Oui$/, 'Yes')
      .replace(/^Non$/, 'No');
  };

  const escapeHtml = (s) =>
    String(s ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const evalClo = (clo) => {
    if (!clo || !clo.whens || !clo.whens.length) return true;
    const results = clo.whens.map((w) => {
      const cur = state.values[w.select];
      const val = Array.isArray(cur) ? cur : cur != null ? [cur] : [];
      const target = String(w.value ?? '');
      if (w.where === 'EQUALS') return val.some((v) => String(v) === target);
      if (w.where === 'NOT_EQUALS') return val.every((v) => String(v) !== target);
      if (w.where === 'CONTAINS') return val.some((v) => String(v).includes(target));
      return val.some((v) => String(v) === target);
    });
    const ok = clo.match === 'any' ? results.some(Boolean) : results.every(Boolean);
    return clo.display === 'hide' ? !ok : ok;
  };

  const isVisible = (el) => {
    if (!el.clo) return true;
    return evalClo(el.clo);
  };

  const getAddonCents = () => {
    let total = 0;
    const variantIds = [];
    if (!state.config) return { total, variantIds };
    for (const el of state.config.elements) {
      if (!isVisible(el)) continue;
      const cur = state.values[el.id];
      if (cur == null || cur === '') continue;
      const selected = Array.isArray(cur) ? cur : [cur];
      for (const val of selected) {
        const ov = (el.values || []).find((v) => v.value === val);
        if (!ov) continue;
        if (ov.price) total += Math.round(parseFloat(ov.price) * 100);
        if (ov.variant_id) variantIds.push(Number(ov.variant_id));
      }
    }
    return { total, variantIds: [...new Set(variantIds)] };
  };

  const updatePrice = () => {
    if (!priceEl) return;
    const { total } = getAddonCents();
    const sum = basePrice + total;
    priceEl.textContent = formatMoney(sum);
    priceEl.setAttribute('content', String(sum / 100));
  };

  /** Compress large images so uploads stay reliable on mobile. */
  const prepareFile = async (file) => {
    if (!file.type.startsWith('image/') || file.size < 1_800_000) return file;
    try {
      const bitmap = await createImageBitmap(file);
      const max = 2000;
      const scale = Math.min(1, max / Math.max(bitmap.width, bitmap.height));
      const w = Math.max(1, Math.round(bitmap.width * scale));
      const h = Math.max(1, Math.round(bitmap.height * scale));
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(bitmap, 0, 0, w, h);
      bitmap.close?.();
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.85));
      if (!blob || blob.size >= file.size) return file;
      const base = file.name.replace(/\.[^.]+$/, '') || 'image';
      return new File([blob], `${base}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
    } catch {
      return file;
    }
  };

  /**
   * Shopify can't store cart files natively. Upload to a CORS-friendly host
   * and put the public URL in the line-item property.
   * Note: catbox.moe/user/api.php intentionally omits ACAO → browser can't read the URL.
   */
  const uploadToGofile = async (file) => {
    const serversRes = await fetch('https://api.gofile.io/servers');
    if (!serversRes.ok) throw new Error('gofile servers');
    const serversBody = await serversRes.json();
    const server = serversBody?.data?.servers?.[0]?.name;
    if (!server) throw new Error('gofile server missing');
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch(`https://${server}.gofile.io/contents/uploadfile`, {
      method: 'POST',
      body: fd,
    });
    if (!res.ok) throw new Error(`gofile ${res.status}`);
    const body = await res.json();
    const page = body?.data?.downloadPage;
    if (!page || !/^https?:\/\//i.test(page)) throw new Error('gofile url');
    return page;
  };

  const uploadToLitterbox = async (file) => {
    const fd = new FormData();
    fd.append('reqtype', 'fileupload');
    fd.append('time', '72h');
    fd.append('fileToUpload', file);
    const res = await fetch('https://litterbox.catbox.moe/resources/internals/api.php', {
      method: 'POST',
      body: fd,
    });
    if (!res.ok) throw new Error(`litterbox ${res.status}`);
    const url = (await res.text()).trim();
    if (!/^https?:\/\//i.test(url)) throw new Error('litterbox url');
    return url;
  };

  const uploadFile = async (file) => {
    const prepared = await prepareFile(file);
    const errors = [];
    for (const attempt of [uploadToGofile, uploadToLitterbox]) {
      try {
        return await attempt(prepared);
      } catch (err) {
        errors.push(err?.message || String(err));
      }
    }
    throw new Error(
      tr('Impossible d’envoyer la photo « ') +
        file.name +
        tr(' ». Réessaie ou réduis la taille du fichier. (') +
        errors.join(' / ') +
        ')'
    );
  };

  const renderField = (el) => {
    const wrap = document.createElement('div');
    wrap.className = 'rm-opt';
    wrap.dataset.optId = el.id;
    wrap.dataset.optType = el.type;

    if (el.type === 'heading') {
      wrap.className = 'rm-opt rm-opt--heading';
      wrap.innerHTML = `<h3 class="rm-opt__heading">${escapeHtml(tr(el.text || el.label))}</h3>`;
      return wrap;
    }
    if (el.type === 'divider') {
      wrap.className = 'rm-opt rm-opt--divider';
      wrap.innerHTML = '<hr class="rm-opt__divider">';
      return wrap;
    }
    if (el.type === 'paragraph') {
      wrap.className = 'rm-opt rm-opt--paragraph';
      wrap.innerHTML = `<p class="rm-opt__paragraph">${escapeHtml(tr(el.text || el.helptext || el.label))}</p>`;
      return wrap;
    }

    const label = tr(el.label || el.cart || el.id);
    const req = el.required ? '<span class="rm-opt__req" aria-hidden="true">*</span>' : '';
    const help = el.helptext
      ? `<p class="rm-opt__help">${escapeHtml(tr(el.helptext))}</p>`
      : '';

    let control = '';
    const name = `rmopt-${el.id}`;

    if (el.type === 'text') {
      control = `<input class="rm-opt__input" type="text" id="${name}" data-opt-input="${el.id}" placeholder="${escapeHtml(tr(el.placeholder || ''))}" ${el.required ? 'required' : ''}>`;
    } else if (el.type === 'textarea') {
      control = `<textarea class="rm-opt__input rm-opt__textarea" id="${name}" data-opt-input="${el.id}" rows="4" placeholder="${escapeHtml(tr(el.placeholder || ''))}" ${el.required ? 'required' : ''}></textarea>`;
    } else if (el.type === 'select') {
      const opts = [`<option value="">${escapeHtml(tr(el.placeholder || '— Choisir —'))}</option>`]
        .concat(
          (el.values || []).map((v) => {
            const price = v.price ? ` (+${v.price}€)` : '';
            return `<option value="${escapeHtml(v.value)}">${escapeHtml(trShow(v.value))}${price}</option>`;
          })
        )
        .join('');
      control = `<select class="rm-opt__input" id="${name}" data-opt-input="${el.id}" ${el.required ? 'required' : ''}>${opts}</select>`;
    } else if (el.type === 'radio' || el.type === 'buttons') {
      control = `<div class="rm-opt__choices" role="radiogroup" aria-label="${escapeHtml(label)}">`;
      for (const v of el.values || []) {
        const price = v.price ? ` <span class="rm-opt__price">+${escapeHtml(v.price)}€</span>` : '';
        control += `<label class="rm-opt__choice"><input type="radio" name="${name}" value="${escapeHtml(v.value)}" data-opt-input="${el.id}" ${el.required ? 'required' : ''}><span>${escapeHtml(trShow(v.value))}${price}</span></label>`;
      }
      control += '</div>';
    } else if (el.type === 'image-swatches') {
      const multi = !!el.allow_multiple;
      const inputType = multi ? 'checkbox' : 'radio';
      const w = Number(el.image_width) || 80;
      const labelLower = String(label).toLowerCase();
      const isPieces =
        multi ||
        w >= 150 ||
        labelLower.includes('pièces') ||
        labelLower.includes('parties') ||
        labelLower.includes('réimprimer') ||
        labelLower.includes('reimprimer');
      const isCompact = !isPieces && w <= 100;
      const sizeClass = isPieces
        ? 'rm-opt__swatches--pieces rm-opt__swatches--cols-3'
        : isCompact
          ? 'rm-opt__swatches--compact'
          : '';
      control = `<div class="rm-opt__swatches ${sizeClass}" role="group" aria-label="${escapeHtml(label)}">`;
      for (const v of el.values || []) {
        const img = v.image || (v.asset_name ? `${CDN}/${v.asset_name}.jpg` : '');
        const price = v.price ? `<span class="rm-opt__swatch-price">+${escapeHtml(v.price)}€</span>` : '';
        control += `<label class="rm-opt__swatch" title="${escapeHtml(v.value)}">
          <input type="${inputType}" name="${name}" value="${escapeHtml(v.value)}" data-opt-input="${el.id}" ${el.required && !multi ? 'required' : ''}>
          <span class="rm-opt__swatch-face">
            ${img ? `<img src="${escapeHtml(img)}" alt="" loading="lazy">` : ''}
            <span class="rm-opt__swatch-label">${escapeHtml(trShow(v.value))}</span>
            ${price}
          </span>
        </label>`;
      }
      control += '</div>';
    } else if (el.type === 'file') {
      const accept = (el.allowed_extensions || []).map((x) => `.${x}`).join(',') || 'image/*,.pdf,.ai,.eps,.svg';
      control = `<div class="rm-opt__file">
        <input class="rm-opt__file-input" type="file" id="${name}" data-opt-file="${el.id}" accept="${accept}" ${el.allow_multiple ? 'multiple' : ''}>
        <label class="rm-opt__file-btn" for="${name}">${escapeHtml(tr('Choisir un fichier'))}</label>
        <ul class="rm-opt__file-list" data-opt-file-list="${el.id}" hidden></ul>
      </div>`;
    } else {
      return null;
    }

    wrap.innerHTML = `<label class="rm-opt__label" for="${name}">${escapeHtml(label)}${req}</label>${help}${control}`;
    return wrap;
  };

  const syncVisibility = () => {
    if (!state.config) return;
    for (const el of state.config.elements) {
      const node = mount.querySelector(`[data-opt-id="${el.id}"]`);
      if (!node) continue;
      const show = isVisible(el);
      node.hidden = !show;
      node.querySelectorAll('input,select,textarea').forEach((inp) => {
        if (!show) {
          inp.dataset.wasRequired = inp.required ? '1' : '0';
          inp.required = false;
          inp.disabled = true;
        } else {
          inp.disabled = false;
          if (inp.dataset.wasRequired === '1' || (el.required && inp.type !== 'checkbox')) {
            if (el.type === 'image-swatches' && el.allow_multiple) {
              // validated manually
            } else if (inp.type !== 'checkbox' && inp.type !== 'file') {
              inp.required = !!el.required;
            }
          }
        }
      });
    }
    updatePrice();
  };

  const readInput = (el, input) => {
    if (el.type === 'image-swatches' && el.allow_multiple) {
      const checked = [...mount.querySelectorAll(`[data-opt-input="${el.id}"]:checked`)].map((i) => i.value);
      state.values[el.id] = checked;
    } else if (el.type === 'radio' || el.type === 'buttons' || (el.type === 'image-swatches' && !el.allow_multiple)) {
      const checked = mount.querySelector(`[data-opt-input="${el.id}"]:checked`);
      state.values[el.id] = checked ? checked.value : '';
    } else if (el.type === 'file') {
      // handled separately
    } else {
      state.values[el.id] = input.value;
    }
  };

  const bind = () => {
    mount.addEventListener('change', (e) => {
      const t = e.target;
      const id = t.dataset.optInput || t.dataset.optFile;
      if (!id) return;
      const el = state.config.elements.find((x) => x.id === id);
      if (!el) return;
      if (t.dataset.optFile) {
        const files = [...(t.files || [])];
        state.files[id] = files;
        state.values[id] = files.map((f) => f.name).join(', ');
        const list = mount.querySelector(`[data-opt-file-list="${id}"]`);
        if (list) {
          list.hidden = !files.length;
          list.innerHTML = files.map((f) => `<li>${escapeHtml(f.name)} (${Math.round(f.size / 1024)} Ko)</li>`).join('');
        }
      } else {
        readInput(el, t);
      }
      syncVisibility();
    });
    mount.addEventListener('input', (e) => {
      const t = e.target;
      const id = t.dataset.optInput;
      if (!id) return;
      const el = state.config.elements.find((x) => x.id === id);
      if (!el) return;
      if (el.type === 'text' || el.type === 'textarea') {
        state.values[id] = t.value;
      }
    });
  };

  const optionError = () => {
    let node = form?.querySelector('[data-rm-opt-error]');
    if (node || !addBtn) return node;
    node = document.createElement('p');
    node.className = 'rm-opt__error';
    node.setAttribute('data-rm-opt-error', '');
    node.hidden = true;
    addBtn.parentElement?.insertBefore(node, addBtn);
    return node;
  };

  const showOptionError = (message, node) => {
    const error = optionError();
    if (error) {
      error.hidden = false;
      error.textContent = message;
    }
    node?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const clearOptionError = () => {
    const error = form?.querySelector('[data-rm-opt-error]');
    if (!error) return;
    error.hidden = true;
    error.textContent = '';
  };

  const validate = () => {
    for (const el of state.config.elements) {
      if (!isVisible(el) || !el.required) continue;
      if (el.type === 'heading' || el.type === 'divider' || el.type === 'paragraph') continue;
      const node = mount.querySelector(`[data-opt-id="${el.id}"]`);
      if (el.type === 'file') {
        if (!(state.files[el.id] || []).length) {
          showOptionError(`${tr('Champ obligatoire : ')}${tr(el.label)}`, node);
          return false;
        }
        continue;
      }
      if (el.type === 'image-swatches' && el.allow_multiple) {
        if (!(state.values[el.id] || []).length) {
          showOptionError(`${tr('Sélectionne au moins une option : ')}${tr(el.label)}`, node);
          return false;
        }
        continue;
      }
      const val = state.values[el.id];
      if (val == null || val === '' || (Array.isArray(val) && !val.length)) {
        showOptionError(`${tr('Champ obligatoire : ')}${tr(el.label)}`, node);
        const inp = node?.querySelector('select, textarea, input[type="text"]');
        if (inp) {
          inp.focus();
          inp.reportValidity();
        }
        return false;
      }
    }
    clearOptionError();
    return true;
  };

  const buildProperties = async () => {
    const props = {};
    for (const el of state.config.elements) {
      if (!isVisible(el)) continue;
      if (['heading', 'divider', 'paragraph'].includes(el.type)) continue;
      const key = el.cart || el.label || el.id;
      if (el.type === 'file') {
        const files = state.files[el.id] || [];
        if (!files.length) continue;
        const urls = [];
        for (let i = 0; i < files.length; i += 1) {
          const file = files[i];
          if (addBtn) {
            addBtn.textContent = `${tr('Envoi des photos…')} ${i + 1}/${files.length}`;
          }
          const url = await uploadFile(file);
          urls.push(`${file.name}: ${url}`);
        }
        props[key] = urls.join('\n');
      } else {
        const val = state.values[el.id];
        if (val == null || val === '') continue;
        props[key] = Array.isArray(val) ? val.join(', ') : String(val);
      }
    }
    return props;
  };

  const postCartItems = async (items) => {
    const res = await fetch(`${cartRoot()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(body.description || body.message || `Erreur panier (${res.status})`);
    return body;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!validate()) return;

    const variantInput = form.querySelector('[data-rm-variant-id]');
    const variantId = Number(variantInput?.value || 0);
    if (!variantId) {
      alert(tr('Variante produit introuvable'));
      return;
    }

    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = tr('Préparation…');
    }

    try {
      const properties = await buildProperties();
      const { variantIds } = getAddonCents();
      const qty = Number(form.querySelector('[name="quantity"]')?.value || 1);
      const main = { id: variantId, quantity: qty, properties };
      const addons = variantIds.map((id) => ({
        id,
        quantity: 1,
        properties: { Pour: properties['marque'] || properties['Marque'] || 'Options' },
      }));

      if (addBtn) addBtn.textContent = tr('Ajout au panier…');
      try {
        await postCartItems([main, ...addons]);
      } catch (err) {
        console.warn(err);
        await postCartItems([main]);
        for (const addon of addons) {
          try {
            await postCartItems([addon]);
          } catch (e) {
            console.warn('addon skip', e);
          }
        }
      }
      window.location.assign(`${cartRoot()}cart`);
    } catch (err) {
      console.error(err);
      alert(err.message || 'Erreur lors de l’ajout au panier');
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.dataset.label || 'Ajouter au panier';
      }
    }
  };

  const init = async () => {
    if (!assetUrl || !mount) return;
    const res = await fetch(assetUrl);
    if (!res.ok) throw new Error(tr('Impossible de charger les options'));
    state.config = await res.json();
    mount.innerHTML = '';
    for (const el of state.config.elements) {
      const node = renderField(el);
      if (node) mount.appendChild(node);
    }
    bind();
    syncVisibility();
    if (addBtn && !addBtn.dataset.label) addBtn.dataset.label = addBtn.textContent.trim();
    form?.addEventListener('submit', onSubmit);
  };

  init().catch((err) => {
    console.error(err);
    if (mount) mount.innerHTML = `<p class="rm-opt__error">${escapeHtml(tr('Options indisponibles. Réessaie plus tard.'))}</p>`;
  });
})();
